import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import moment from 'moment/moment';

import { EnvironmentService } from '../core/environment.service';
import { LoadingOverlayService } from '../loading-overlay/loading-overlay.service';

@Component({
    selector: 'app-konto',
    templateUrl: './konto.component.html',
    styleUrls: ['./konto.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KontoComponent {
    environmentService = inject(EnvironmentService);
    private loadingOverlayService = inject(LoadingOverlayService);

    public fontsizes: number[] = [24, 16, 14, 12];

    public currentFontSize = window.getComputedStyle(document.getElementsByTagName('html')[0]).fontSize;

    public setFontSize(size: number) {
        // console.log(this.currentFontSize);

        switch (this.currentFontSize) {
            case '12px':
                document.getElementsByTagName('html')[0].classList.remove('fs-12');
                break;
            case '14px':
                document.getElementsByTagName('html')[0].classList.remove('fs-14');
                break;
            case '16px':
                document.getElementsByTagName('html')[0].classList.remove('fs-16');
                break;
            case '24px':
                document.getElementsByTagName('html')[0].classList.remove('fs-24');
                break;
        }

        switch (size) {
            case 12:
                document.getElementsByTagName('html')[0].classList.add('fs-12');
                this.currentFontSize = '12px';
                break;
            case 14:
                document.getElementsByTagName('html')[0].classList.add('fs-14');
                this.currentFontSize = '14px';
                break;
            case 16:
                document.getElementsByTagName('html')[0].classList.add('fs-16');
                this.currentFontSize = '16px';
                break;
            case 24:
                document.getElementsByTagName('html')[0].classList.add('fs-24');
                this.currentFontSize = '24px';
                break;
        }
    }

    public overideTheme(index: number) {
        const currentTheme = this.getCurrentThemeObject();

        if (this.isCurrentThemeIndex(index)) {
            return;
        }

        // standard theme stylesheet must stay in the page all the time, we only add/replace/remove the alternative theme stylesheet
        if (this.isStandardThemeIndex(index)) {
            this.removeAlternativeThemeLinkElement();
            if (currentTheme) currentTheme.selected = false;
            this.environmentService.themes[index].selected = true;

            return;
        }

        const currentDate = moment(new Date()).format('YYYYMMDD');
        const link: HTMLLinkElement = document.createElement('link');

        link.setAttribute('id', 'theme-link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', this.environmentService.themes[index].name + '.css?ts=' + currentDate);
        link.setAttribute('class', 'theme-settings-theme-css');

        const alternativeThemeLinkElement = this.environmentService.getAlternativeThemeLinkElement();
        if (alternativeThemeLinkElement) {
            alternativeThemeLinkElement?.replaceWith(link);
        } else {
            document.head.appendChild(link);
        }
        if (currentTheme) currentTheme.selected = false;
        this.environmentService.themes[index].selected = true;
    }

    public setMaterial() {
        this.environmentService.isMaterial = !this.environmentService.isMaterial;
        this.setMaterialStyle();
    }

    public setMaterialStyle() {
        const bootstrapLink: HTMLLinkElement = document.createElement('link');

        const material: string = this.environmentService.isMaterial ? '-material' : '';

        bootstrapLink.setAttribute('id', 'bootstrap-link');
        bootstrapLink.setAttribute('rel', 'stylesheet');
        bootstrapLink.setAttribute('href', 'vendor/styles/bootstrap' + material + '.css');
        bootstrapLink.setAttribute('class', 'theme-settings-bootstrap-css');

        // colorsLink.setAttribute('id', 'colors-link');
        // colorsLink.setAttribute('rel', 'stylesheet');
        // colorsLink.setAttribute('href', 'vendor/styles/bootstrap' + material + '.css');
        // colorsLink.setAttribute('class', 'theme-settings-colors-css');

        this.loadingOverlayService.startLoading();
        document.getElementById('bootstrap-link').replaceWith(bootstrapLink);
        const theme = document.createElement('link');

        theme.setAttribute('id', 'theme-link');
        theme.setAttribute('rel', 'stylesheet');
        theme.setAttribute('type', 'text/css');
        theme.setAttribute('href', 'vendor/styles/' + 'theme-orgacard' + '.css');
        theme.setAttribute('class', 'theme-settings-theme-css');

        document.getElementById('theme-link').replaceWith(theme);
        this.loadingOverlayService.stopLoading();
    }

    private getCurrentThemeObject() {
        const currentTheme = this.environmentService.getCurrentThemeName().split('?')[0].replace(/\.css$/, '');
        for (const theme of this.environmentService.themes) {
            if (currentTheme === theme.name) {
                return theme;
            }
        }
    }

    private isStandardThemeIndex(index) {
        return this.environmentService.standardThemeName === this.environmentService.themes[index].name;
    }

    private isCurrentThemeIndex(index) {
        return index === this.environmentService.themes.findIndex((element) => element.selected);
    }

    private removeAlternativeThemeLinkElement() {
        this.environmentService.getAlternativeThemeLinkElement()?.remove();
    }
}
